import React from 'react';
import '../../styles/CaseStudyFour/CaseStudiesTesting4.css';

const CaseStudiesTesting4 = () => {
  return (
    <section className="testing-section4">
      <div className="testing-container4">
        <h2 className="testing-section-title4">Testing and Optimization</h2>
        <p className="testing-section-description4">
        Google’s algorithm is designed to optimize for the cheapest leads possible, which often results in junk and spam leads that do not translate to actual conversions.
         By focusing on scheduled moves instead of lead volume, we ensured that ad spend was directed toward meaningful actions that drive real business outcomes.
        </p>

        {/* Row 1 */}
        <div className="testing-row4">
          <div className="testing-content4">
            <div className="testing-checkmark-icon4"></div>
            <div>
              <h4 className="testing-title4">Audience Refinement</h4>
              <p className="testing-text4">
              We implemented audience refinement using the data collected through End-To-End Tracking. By narrowing the audience based on household incomes and age groups, we focused on those most likely to convert.
              </p>
            </div>
          </div>
          <div className="testing-image-placeholder4">
          <img
              src={require("../../assets/two-movers.png")}
              alt="Bot"
              className="testing-section-image4"
            />
          </div>
        </div>

        {/* Row 2 */}
        <div className="testing-row reverse4">
          <div className="testing-content4">
            <div className="testing-checkmark-icon4"></div>
            <div>
              <h4 className="testing-title4">Keyword Optimization</h4>
              <p className="testing-text4">
              Keyword optimization played a significant role. We honed in on high-performing keywords and specific campaign types that consistently generated moves rather than irrelevant leads.
              </p>
            </div>
          </div>
          <div className="testing-image-placeholder4">
          <img
              src={require("../../assets/magnifying-glass.png")}
              alt="Bot"
              className="testing-section-image4"
            />
          </div>
        </div>

        {/* Row 3 */}
        <div className="testing-row4">
          <div className="testing-content4">
            <div className="testing-checkmark-icon4"></div>
            <div>
              <h4 className="testing-title4">Maximized Efficiency</h4>
              <p className="testing-text4">
              We continuously monitored performance and adjusted bidding strategies to maximize the efficiency of ad spend. These refinements allowed us to scale results effectively without increasing costs.
              </p>
            </div>
          </div>
          <div className="testing-image-placeholder4">
          <img
              src={require("../../assets/time-money-up.png")}
              alt="Bot"
              className="testing-section-image4"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudiesTesting4;